import { useState, useEffect } from "react";
import "./styles.scss";

const ReminderSettings = ({
  onReminderChange,
  onPhoneChange,
  initialPhone = "",
  initialReminderEnabled = false,
  initialReminderType = "email",
  // Current values for optimistic updates
  currentPhone,
  currentReminderEnabled,
  currentReminderType,
  savedIndicators = {},
}) => {
  const [reminderEnabled, setReminderEnabled] = useState(initialReminderEnabled);
  const [reminderType, setReminderType] = useState(initialReminderType);
  const [phone, setPhone] = useState(initialPhone);

  // Use current values if available (for optimistic updates)  
  const effectiveReminderEnabled = currentReminderEnabled !== undefined ? currentReminderEnabled : reminderEnabled;
  const effectiveReminderType = currentReminderType !== undefined ? currentReminderType : reminderType;
  const effectivePhone = currentPhone !== undefined ? currentPhone : phone;

  // Sync with props when they change (after backend data loads)
  useEffect(() => {
    setReminderEnabled(initialReminderEnabled);
  }, [initialReminderEnabled]);

  useEffect(() => {
    setReminderType(initialReminderType);
  }, [initialReminderType]);

  useEffect(() => {
    setPhone(initialPhone);
  }, [initialPhone]);



  const handleReminderToggle = () => {
    const newEnabled = !effectiveReminderEnabled;
    // Optimistic update: immediately update local state
    setReminderEnabled(newEnabled);
    onReminderChange &&
      onReminderChange({
        enabled: newEnabled,
        type: effectiveReminderType,
        phone: effectivePhone,
      });
  };

  const handleReminderTypeChange = (type) => {
    // Optimistic update: immediately update local state
    setReminderType(type);
    onReminderChange &&
      onReminderChange({
        enabled: effectiveReminderEnabled,
        type: type,
        phone: effectivePhone,
      });
  };

  const handlePhoneChange = (event) => {
    const newPhone = event.target.value;
    // Optimistic update: immediately update local state
    setPhone(newPhone);
    onPhoneChange && onPhoneChange(newPhone);
    onReminderChange &&
      onReminderChange({
        enabled: effectiveReminderEnabled,
        type: effectiveReminderType,
        phone: newPhone,
      });
  };

  return (
    <div className="reminder-settings">
      <div className="reminder-toggle">
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={effectiveReminderEnabled}
            onChange={handleReminderToggle}
          />
          <span className="slider"></span>
        </label>
        <span className="toggle-label">
          Нагадати, коли дитина буде готова до навчання
        </span>
      </div>

      {effectiveReminderEnabled && (
        <div className="reminder-options">
          <div className="reminder-type-section">
            <div className="section-header">
              <p className="section-label">Як нагадати:</p>
              {savedIndicators.reminder && (
                <div className="save-indicator">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                      fill="#22c55e"
                    />
                  </svg>
                </div>
              )}
            </div>
            <div className="radio-group">
              <label
                className={`radio-option${
                  effectiveReminderType === "email" ? " is-selected" : ""
                }`}
              >
                <input
                  type="radio"
                  name="reminderType"
                  value="email"
                  checked={effectiveReminderType === "email"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleReminderTypeChange("email");
                    }
                  }}
                />
                <span className="radio-visual" aria-hidden="true"></span>
                <span className="radio-label">Електронна пошта</span>
              </label>
              <label
                className={`radio-option${
                  effectiveReminderType === "sms" ? " is-selected" : ""
                }`}
              >
                <input
                  type="radio"
                  name="reminderType"
                  value="sms"
                  checked={effectiveReminderType === "sms"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleReminderTypeChange("sms");
                    }
                  }}
                />
                <span className="radio-visual" aria-hidden="true"></span>
                <span className="radio-label">SMS</span>
              </label>
            </div>
          </div>

          {effectiveReminderType === "sms" && (
            <div className="phone-input-section">
              <div className="phone-header">
                <label htmlFor="phone-input" className="phone-label">
                  Номер телефону:
                </label>
                {savedIndicators.phone && (
                  <div className="save-indicator">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                        fill="#22c55e"
                      />
                    </svg>
                  </div>
                )}
              </div>
              <input
                id="phone-input"
                type="tel"
                value={effectivePhone}
                onChange={handlePhoneChange}
                placeholder="+380"
                className="phone-input"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ReminderSettings;
